// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"1d61538a3e4ea7b6cec2","293":"a5674e09e13211d47f10"}[chunkId] + ".js";
};